module.exports = "query GetNotificationCount {\n  notificationCount\n}\n"